export const dashboardTextButtonDataHook = 'dashboard-text-button';
